export const CONSTRAINT_CONSTANTS = {
  DEFAULT_PERCENTAGE: 0.3,
  MIN_VALUE: 0,
  MAX_VALUE: Infinity,
};

export const FIXED_SPEND_CHANNELS = ['email', 'cj', 'sms', 'dm', 'connexity'];

export const PERCENTAGE_OPTIONS = [
  { text: 'Optional', value: false },
  { text: '15% (Tight)', value: 0.15 },
  { text: '30% (Recommended)', value: 0.3 },
  { text: '50%', value: 0.5 },
  { text: '100%', value: 1 },
];

export const MODE_OPTIONS = [
  { value: 'percentage', label: 'Percentage' },
  { value: 'manual', label: 'Manual' },
];
